import { useEffect, useState, useMemo } from 'react'
import { AdasBox, AdasButton, AdasTextField, AdasTypography } from '@components/wrapper-components'
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined'

export const NoteForm = ({ cancel, submit, allowEdit = true, existingNote, label, noteType, maxLength, txAreaBgColor }) => {
  const [note, setNote] = useState(existingNote || '')
  const [isEdit, setIsEdit] = useState(!existingNote)

  useEffect(() => {
    setNote(existingNote || '')
  }, [existingNote])

  useEffect(() => {
    setIsEdit(!existingNote)
  }, [noteType])
  const handleChange = (e) => setNote(e.target.value)
  const handleSubmit = () => {
    submit(note)
    setIsEdit(false)
  }

  const handleCancel = () => {
    setIsEdit(false)
    cancel()
  }

  const internalNoteText = noteType === 'client_note' ? '* Internal Use Only: Not Shown on Invoice' : ''

  const sharedTextFieldStyles = {
    marginBottom: '0px',
    '.MuiInputBase-root': txAreaBgColor ? { backgroundColor: txAreaBgColor } : undefined,
    '.MuiInputBase-root.Mui-disabled': {
      color: 'black',
      WebkitTextFillColor: 'black'
    },
    '.MuiInputBase-input.Mui-disabled': {
      color: 'black',
      WebkitTextFillColor: 'black'
    }
  }

  const ActionButtons = useMemo(
    () => (
      <AdasBox sx={{ margin: '20px 0px', overflow: 'auto' }} display='flex' alignItems='center' justifyContent='space-between'>
        <AdasTypography variant='subtitle2' sx={{ fontWeight: '600' }}>
          {internalNoteText}
        </AdasTypography>
        <AdasBox sx={{ float: 'right' }}>
          {isEdit ? (
            <>
              <AdasButton variant='outlined' aria-label='cancel' color='primary' onClick={handleCancel} sx={{ marginRight: '10px' }}>
                Cancel
              </AdasButton>
              <AdasButton variant='contained' aria-label='save' color='primary' onClick={handleSubmit} disabled={!note?.trim()}>
                Save
              </AdasButton>
            </>
          ) : (
            allowEdit && (
              <AdasButton
                startIcon={<ModeEditOutlineOutlinedIcon />}
                aria-label='edit note'
                color='primary'
                onClick={() => setIsEdit(true)}
              >
                Edit
              </AdasButton>
            )
          )}
        </AdasBox>
      </AdasBox>
    ),
    [isEdit, internalNoteText, allowEdit, note]
  )

  return (
    <AdasBox sx={{ margin: isEdit ? '15px 20px' : '20px 20px' }}>
      <AdasTypography variant='subtitle2' sx={{ fontWeight: '600' }}>
        {label}
      </AdasTypography>

      <AdasTextField
        multiline
        rows={4}
        name='note'
        id='note'
        value={isEdit ? note : existingNote}
        onChange={isEdit ? handleChange : undefined}
        fullWidth
        disabled={!isEdit}
        variant='outlined'
        helperText={isEdit ? `Maximum ${maxLength} Characters ${maxLength - note.length} remaining` : ''}
        sx={sharedTextFieldStyles}
        InputLabelProps={{ shrink: true }}
        inputProps={isEdit ? { maxLength } : {}}
      />

      {allowEdit && ActionButtons}
    </AdasBox>
  )
}
